<script>
  import { createEventDispatcher, onMount } from 'svelte';

  const dispatch = createEventDispatcher();

  import Avatar from '@ctm/ui/Avatar';
  import Dropdown from '@ctm/ui/Dropdown';
  import Tag from '@ctm/ui/Tag';

  import NavMenu from './NavMenu.svelte';
  import { ArrowDown } from '@ctm/ui/Icons';
  import logo from './logo.svg';
  import getInitials from '../../util/getInitials';

  import {
    userInfo,
    isAnonymousUser,
    usersName,
    usersEmail,
    usersDebtor,
    usersInitials
  } from '../../store/index.js';


  let activeRoute;
  let getMenuContainer = () => document.getElementById('nav');
  let isNavMenuActive = undefined;


  function onDropdownSelect(event) {
    if (event.detail === 'SIGN_OUT') {
      dispatch('signOut');
    }

    else {
      dispatch('goto', event.detail);
    }
  }

  function onNavItemClick(stateName, event) {
    event.preventDefault();
    dispatch('goto', stateName);
  }

  function onWindowHashChange() {
    activeRoute = window.location.hash.substring(2).split('/')[0];
  }

  function init() {
    const _userInfo = JSON.parse(localStorage.getItem('CURRENT_USER_userInfo'));

    if ($userInfo && _userInfo && _userInfo.Email && $userInfo.Email !== _userInfo.Email) {
      window.location.pathname = '/';
      window.location.hash = '#/search';
      location.reload();
    }

    if (_userInfo && _userInfo.Name) {
      const names = _userInfo.Name.split(' ');

      $userInfo = _userInfo;
      $isAnonymousUser = _userInfo.IsAnonymousUser;
      $usersName = _userInfo.Name;
      $usersEmail = _userInfo.Email;
      $usersDebtor = _userInfo.Debtor;
      $usersInitials = names.length > 1 ? getInitials(names[0], names[1]) : '--';

    } else {
      setTimeout(() => {
        dispatch('signOut');
      }, 0);
    }

  }

  onMount(() => {
    onWindowHashChange();

    window.addEventListener('focus', () => {
      init();
    }, false);

    init();
  });
</script>

<svelte:window on:hashchange="{onWindowHashChange}" />

<div id="nav" class="nav { $isAnonymousUser ? 'hideContents' : ''}">
  <div class="layout">
    <div class="logo">
      <img src="{logo}" alt="Lightning Book">
    </div>

    {#if !$isAnonymousUser}
    <div class="menu">
      <div class="menu_items">
        <a
          href="/#/search"
          on:click="{event => onNavItemClick('app.home.search', event)}"
          class="{ activeRoute === 'search' ? 'active' : '' }"
          title="New Booking"
        >
          <span>New Booking</span>
        </a>

        <a
          href="/#/manage-bookings"
          on:click="{event => onNavItemClick('app.home.manage', event)}"
          class="{ ['manage-bookings', 'airport-transfers'].includes(activeRoute) ? 'active' : '' }"
          title="Manage Bookings"
        >
          <span>Manage Bookings</span>
        </a>

        <!-- <a
        href="/#/slipstream"
        on:click="{event => onNavItemClick('app.home.slipstream', event)}"
        class="{ activeRoute === 'slipstream' ? 'active' : '' }"
        title="Slipstream"
      >        
          <span>Slipstream</span>
          <span class="beta"><Tag backgroundColour="#ff9500">BETA</Tag></span>
        </a>   -->
  
      </div>
    </div>
    {/if}

    <Dropdown
      MenuComponent="{ NavMenu }"
      placement="bottomRight"
      { getMenuContainer }
      bind:isActive="{isNavMenuActive}"
      on:select="{onDropdownSelect}"
      width="275px">
      <div class="avatarMenu {isNavMenuActive ? 'active' : ''}" title="{$usersName}">
        <Avatar alt="{$usersInitials}" textColour="#b0b7be" bgColour="#ebedef"></Avatar>
        <span>{$usersName}</span>
        <div class="arrowDown">
          <ArrowDown />
        </div>
      </div>
    </Dropdown>
  </div>
</div>

<style>
  .nav {
    background: #000;
    height: 64px;
    padding: 0 32px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1003;
  }

  .layout {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .logo {
    width: 115px;
    position: relative;
    top: 2px;
  }

  .logo img {
    width: 100%;
  }

  .menu {
    display: none;
  }

  .hideContents .menu {
    display: none;
  }

  .avatarMenu {
    display: flex;
    align-items: center;
    color: #707C84;
    height: 64px;

  }

  .avatarMenu span {
    padding-left: 8px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.31px;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: none;
    white-space: nowrap;
    display: none;
  }

  .avatarMenu .arrowDown {
    width: 25px;
    height: 28px;
    position: relative;
    display: none;
  }

  .avatarMenu:hover,
  .avatarMenu.active {
    color: #fff;
  }

  @media (min-width: 768px) {
    .menu {
      display: flex;
      align-items: stretch;
      align-self: stretch;
      flex-grow: 1;
      justify-content: space-between;
      padding-left: 56px;
    }

    .menu_items {
      display: flex;
      align-items: stretch;
    }

    .menu_items a {
      display: flex;
      align-items: center;
      color: #737f89;
      font-size: 14px;
      margin-right: 34px;
      transition: box-shadow 0.15s ease;
    }

    .menu_items a.active {
      box-shadow: 0 -8px 0 -4px #51ce6c inset;
      color: #fff;
      font-weight: 600;
    }

    .menu_items a:hover {
      color: #fff;
    }

    .avatarMenu span,
    .avatarMenu .arrowDown {
      display: block;
    }

    .menu_items a {
      position: relative;
    }
  }
</style>
